var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 8.66699C19.0572 8.66699 20.7105 9.35181 21.9294 10.5708C23.1484 11.7898 23.8333 13.4431 23.8333 15.167V22.7503H19.4999V15.167C19.4999 14.5924 19.2716 14.0413 18.8653 13.6349C18.459 13.2286 17.9079 13.0003 17.3333 13.0003C16.7586 13.0003 16.2075 13.2286 15.8012 13.6349C15.3949 14.0413 15.1666 14.5924 15.1666 15.167V22.7503H10.8333V15.167C10.8333 13.4431 11.5181 11.7898 12.7371 10.5708C13.956 9.35181 15.6093 8.66699 17.3333 8.66699Z",
    stroke: "#5775FF",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50008 9.75H2.16675V22.75H6.50008V9.75Z",
    stroke: "#5775FF",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33341 6.50033C5.53003 6.50033 6.50008 5.53028 6.50008 4.33366C6.50008 3.13704 5.53003 2.16699 4.33341 2.16699C3.1368 2.16699 2.16675 3.13704 2.16675 4.33366C2.16675 5.53028 3.1368 6.50033 4.33341 6.50033Z",
    stroke: "#5775FF",
    strokeWidth: 1.73333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cd14b63088676abda61726c1753ef9ef.svg";
export { ForwardRef as ReactComponent };